<div [formGroup]="formGroup">
  <div class="row">
    <div class="col-sm-12">
      <h6>Does this company have its own accountant that we can contact?</h6>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <p>
        <mat-checkbox
          formControlName="companyHasAccountant"
          (change)="toggleAccountantConfirmation($event)"
        >Yes, they do.</mat-checkbox>
      </p>
    </div>
  </div>

  <div class="row" *ngIf="accountantConfirmation">
    <div class="col-sm-12">
      <h4>Accountant details</h4>
    </div>
  </div>

  <div class="row" *ngIf="accountantConfirmation">
    <div class="col-sm-12">
      <fmc-abn-search
          [parentFormGroup]="formGroup"
          [controlName]="'companyAccountantAbn'"
          [placeholderText]="'ABN search'"
      ></fmc-abn-search>
      <mat-error>
        <app-validation-partial
          [formGroup]="formGroup"
          [fieldName]="'companyAccountantAbn'"
        ></app-validation-partial>
      </mat-error>
    </div>
  </div>

  <div class="row" *ngIf="accountantConfirmation">
    <div class="col-sm-4">
      <mat-form-field appearance="outline">
        <mat-label>Contact name</mat-label>
        <input matInput placeholder="Contact name" formControlName="companyAccountantContactName">
        <mat-error>
          <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'companyAccountantContactName'"
          ></app-validation-partial>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <fmc-sensis-mobile
        [parentFormGroup]="formGroup"
        [controlName]="'companyAccountantPhone'"
        [placeholderText]="'Phone number'"
      ></fmc-sensis-mobile>
    </div>
    <div class="col-sm-4">
      <fmc-sensis-email
        [parentFormGroup]="formGroup"
        [controlName]="'companyAccountantEmail'"
        [placeholderText]="'Email address'"
      ></fmc-sensis-email>
    </div>
  </div>
</div>
